import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import downloadIcon from "../../../Assets/Images/Operation/downloadIcon.svg";
import { compName } from "../../../utils/constant";
import WidgetDetailModal from "../WidgetDetailModal";
import { useSelector } from "react-redux";
import infoIcon from "../../../Assets/Images/Action Icons/infoIcon..svg";
import { useParams } from "react-router-dom";
import emailIcon from "../../../Assets/Images/Email.svg";
import Comments from "../ListingComponent/Comments/Comment";
import moment from "moment";
import { API_URL } from "../../../utils/apiRoutes";
import { apiCall } from "../../../utils/axiosService";
import { apiResponse } from "../../../utils/apiResponse";
import "../../../Assets/Styles/component.css";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import MorningBriefingMarketShareDetailModal from "./MorningBriefingMarketShareDetailModal";
import Loader from "../../Loader/Loader";
import { commonService } from "../../../utils/commonService";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
);

const MarketShare = ({
  setCompDataFromChild,
  rowIndex,
  colIndex,
  api,
  para,
  setting,
}) => {
  const { snapshottitle, propertyCode, snapshotId } = useParams();
  const propertyDetailFromRTK = useSelector(
    (store) => store.headerProperty?.propertyDetail,
  );
  const defaultAsOfDateFromRTK = useSelector(
    (store) => store.headerProperty?.defaultAsOfDate,
  );
  const [tblids, settblids] = useState({
    MarketShareTable: commonService.GenerateGUID(),
  });
  const widgetDetailRef = React.useRef();
  const [widgetModal, setWidgetModal] = useState(false);
  const closeWidgetModal = () => {
    setWidgetModal(false);
  };
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showDetail, setShowDetail] = useState(false);

  const getMarketShareData = async () => {
    setLoading(true);

    let MarketShareResponse = await apiCall(
      {
        method: "POST",
        url:
          API_URL.BASE_API_URL.SnapShot +
          API_URL.MORNING_BRIEFING.GET_MARKET_SHARE,
        body: {
          propertycode:
            para?.propertyDetail?.propertycode || para?.propertyCode,
          selecteddate: para?.asOfDate,
          weekcount: 12,
        },
      },
      false,
    );

    let response = apiResponse(false, MarketShareResponse);

    if (response?.isValidate) {
      let dataFromApi = response?.data?.data?.details || [];
      setData(dataFromApi);
    } else {
      setData([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (api === 0) {
      const staticData = [];
      for (let i = 0; i < 12; i++) {
        staticData.push({
          dow: "Total",
          mpi: (100 + Math.sin(i * 0.5) * 5 + (i % 3)).toFixed(1),
          ari: (98 + Math.cos(i * 0.4) * 4 + (i % 2)).toFixed(1),
          rgi: (99 + Math.sin(i * 0.3) * 6).toFixed(1),
          week_start_date: moment().subtract(12 - i, "weeks").format("YYYY-MM-DD"),
          week_end_date: moment().subtract(12 - i, "weeks").add(6, "days").format("YYYY-MM-DD"),
        });
      }
      setData(staticData);
      setLoading(false);
    } else {
      if (para?.asOfDate && para?.propertyCode) {
        getMarketShareData();
      }
    }
  }, [para?.asOfDate, para?.propertyCode, api]);

  const safeData = Array.isArray(data)
    ? data.filter((d) => d.dow === "Total").reverse()
    : [];

  const chartData = {
    labels: safeData.map((item, index) => {
      const start = item.week_start_date ? moment(item.week_start_date).format("MM/DD") : "";
      const end = item.week_end_date ? moment(item.week_end_date).format("MM/DD") : "";
      if (start && end) {
        return [`Wk-${safeData?.length - index}`, `(${start} - ${end})`];
      }
      return `Wk-${safeData?.length - index}`;
    }),
    datasets: [
      {
        label: "MPI (occupancy share)",
        data: safeData.map((item) => parseFloat(item.mpi) || 0),
        borderColor: "#3b82f6",
        backgroundColor: "#3b82f6",
        borderWidth: 2,
        tension: 0.1,
        pointRadius: 0,
        pointHoverRadius: 4,
      },
      {
        label: "ARI (rate share)",
        data: safeData.map((item) => parseFloat(item.ari) || 0),
        borderColor: "#06b6d4",
        backgroundColor: "#06b6d4",
        borderWidth: 2,
        tension: 0.1,
        pointRadius: 0,
        pointHoverRadius: 4,
      },
      {
        label: "RGI (RevPAR share)",
        data: safeData.map((item) => parseFloat(item.rgi) || 0),
        borderColor: "#f59e0b",
        backgroundColor: "#f59e0b",
        borderWidth: 2,
        tension: 0.1,
        pointRadius: 0,
        pointHoverRadius: 4,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        align: "center",
        labels: {
          color: "#64748b",
          usePointStyle: false,
          boxWidth: 8,
          boxHeight: 8,
          padding: 20,
          font: {
            size: 13,
            family: "system-ui, -apple-system, sans-serif",
          },
        },
      },
      tooltip: {
        mode: "index",
        intersect: false,
        backgroundColor: "rgba(255, 255, 255, 0.95)",
        titleColor: "#0f172a",
        bodyColor: "#334155",
        borderColor: "#e2e8f0",
        borderWidth: 1,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
          drawBorder: false,
        },
        ticks: {
          color: "#64748b",
          font: {
            size: 11,
            family: "system-ui, -apple-system, sans-serif",
          },
          maxRotation: 0,
          minRotation: 0,
        },
      },
      y: {
        grid: {
          color: "#f1f5f9",
          drawBorder: false,
        },
        border: {
          display: false,
        },
        ticks: {
          color: "#64748b",
          padding: 10,
          font: {
            size: 12,
            family: "system-ui, -apple-system, sans-serif",
          },
          callback: function (value) {
            return value.toFixed(2);
          },
        },
      },
    },
    interaction: {
      mode: "nearest",
      axis: "x",
      intersect: false,
    },
  };

  return (
    <div className="widget-container" style={{ position: "relative" }}>
      {api !== 0 && (
        <div className="gap-1 widget-container-menu">
          {/* <Button className="heading-menu-btns" type="button" title="Send Mail">
            <img
              id={commonService.generateGlobalClickTrackerID("MarketShare","emailIcon", propertyDetailFromRTK?.propertyid)}
              src={emailIcon}
              alt="emailIcon"
              onClick={() => {
                commonService.fnSendWidgetMail(
                  tblids.MarketShareTable,
                  "MarketShare",
                  snapshotId,
                  defaultAsOfDateFromRTK,
                  "",
                  para?.widgetId
                );
              }}
            />
          </Button> */}
          <Button className="heading-menu-btns" type="button">
            <img
              id={commonService.generateGlobalClickTrackerID(
                "MarketShare",
                "infoIcon",
                propertyDetailFromRTK?.propertyid,
              )}
              src={infoIcon}
              alt="info"
              onClick={() => {
                widgetDetailRef.current = {
                  widgetdetails: "",
                  usernote: "",
                  compName: compName?.MarketShare || "MarketShare",
                  widgetId: para?.widgetId,
                };
                setWidgetModal(true);
              }}
            />
          </Button>
          {/* <Button className="heading-menu-btns" type="button">
            <img
              src={downloadIcon}
              alt="menuIcon"
              id={commonService.generateGlobalClickTrackerID("MarketShare","downloadIcon", propertyDetailFromRTK?.propertyid)}
              onClick={() =>
                commonService.fnExportInCSV(
                  tblids.MarketShareTable,
                  `${para?.propertyCode}-MarketShare-${moment(new Date()).format("MMDDYYYY")}`
                )
              }
            />
          </Button> */}
        </div>
      )}
      <div className="morning-briefing-header mb-30">
        <div>
          {/* <h2 className="morning-briefing-title">
            Market Share — MPI • ARI • RGI, 12 Weeks
          </h2> */}
        </div>
        <div>
          <Button
            id={commonService.generateGlobalClickTrackerID(
              "MarketShare",
              "STR-Benchmarking-btn-click",
            )}
            onClick={(e) => {
              e.preventDefault();
              if (api === 0) return;
              setShowDetail(true);
            }}
            className="default-btn primary-btn cursor-pointer ms-0"
          >
            STR Benchmarking &rarr;
          </Button>
        </div>
      </div>

      {loading ? (
        <div className="p-4 text-center">
          <Loader />
        </div>
      ) : (
        <div className="market-share-chart-container">
          <Line data={chartData} options={options} />
        </div>
      )}
      {safeData && showDetail && (
        <MorningBriefingMarketShareDetailModal
          showDetail={showDetail}
          setShowDetail={setShowDetail}
          marketShareData={safeData}
        />
      )}
      {api !== 0 && (
        <Comments
          widgetDetails={para}
          editorId={"MarketShare" + tblids.MarketShareTable}
        />
      )}
      {widgetModal && (
        <WidgetDetailModal
          showModal={widgetModal}
          closeModal={closeWidgetModal}
          data={widgetDetailRef.current}
        />
      )}
    </div>
  );
};

export default MarketShare;
